module.exports = __webpack_public_path__ + "img/table-lines.749c7440.svg";